export default __webpack_public_path__ + "static/media/1519.2320ded3.png";